import { render } from "./HeroAreaProject.vue?vue&type=template&id=0d39dfee&scoped=true"
import script from "./HeroAreaProject.vue?vue&type=script&lang=js"
export * from "./HeroAreaProject.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0d39dfee"

export default script